export var sizeToInt = function (size) { return parseInt(size || '', 10) || 0; };
